module.exports = __webpack_public_path__ + "img/logo.fad6d114.png";